import { SubmissionStatus } from '../../../enums/submissionStatus'

export const getUiStatus = (status: SubmissionStatus): 'error' | 'success' => {
  switch (status) {
    case SubmissionStatus.AuthenticationFailed:
    case SubmissionStatus.DeliveryFailed:
    case SubmissionStatus.ValidationFailed:
    case SubmissionStatus.UnknownError:
      return 'error'
    default:
      return 'success'
  }
}
